import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import '../styles/App.css';
import Header from './Header.js';
import Home from './Home.js';
import ModeItem from './ModeItem.js';
import ModeGame from './ModeGame.js';
import ModeCharacter from './ModeCharacter.js';
import ModeSword from './ModeSword.js';
import Share from './Share.js';
import Socials from './Socials.js';
import Footer from './Footer.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import About from './About.js';
import Contact from './Contact.js';
import Terms from './Terms.js';
import History from './History.js';
import NotFound from './NotFound.js';
import Library from './Library.js';
import { AdRailLeft, AdRailRight, AdMobile } from './AdsRail.js';
import CookieConsent from './CookieConsent.js';

function App() {
  return (
    <div className="home-container">
      <Router>
        <AdMobile />
        <AdRailLeft />

        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />

          <Route exact path="/item" element={<ModeItem />} />
          <Route exact path="/item/:id" element={<ModeItem />} />

          <Route exact path="/game" element={<ModeGame />} />
          <Route exact path="/game/:id" element={<ModeGame />} />

          <Route exact path="/character" element={<ModeCharacter />} />
          <Route exact path="/character/:id" element={<ModeCharacter />} />

          <Route exact path="/sword" element={<ModeSword />} />
          <Route exact path="/sword/:id" element={<ModeSword />} />

          <Route exact path="/privacy" element={<PrivacyPolicy />} />
          <Route exact path="/terms" element={<Terms />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />

          <Route exact path='/history' element={<History />} />
          <Route exact path='/history/:mode' element={<History />} />
          <Route exact path='/history/:mode/:id' element={<History />} />

          <Route path="/library" element={<Library />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Share />
        <Socials />
        <Footer />
        <CookieConsent />

        <AdRailRight />
      </Router>
    </div>
  )
}

export default App